import React from 'react';
import { motion } from 'framer-motion';
import { BuyButton, scrollToOffer } from './BuyButton';
import { PRODUCT_IMAGE } from '../data/content';
const BADGES = [{
  icon: '📄',
  label: '100% PDF'
}, {
  icon: '⚡️',
  label: 'Instant Delivery'
}, {
  icon: '📚',
  label: '7 Modules + 6 Bonuses'
}];
export function Hero() {
  return <header className="relative px-5 pb-8 pt-8" data-id="element-100">
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="text-center font-display text-4xl font-800 uppercase leading-[0.95] text-white sm:text-5xl" data-id="element-101">
        Build a Profitable{' '}
        <span className="text-[var(--pb-lime)]" data-id="element-102">Pickleball Coaching</span>{' '}
        Business From Scratch
      </motion.h1>

      <motion.button type="button" onClick={scrollToOffer} initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} aria-label="View the offer and get the kit" className="mx-auto mt-6 block w-full max-w-md" data-id="element-103">
        <img src={PRODUCT_IMAGE} alt="Pickleball Coach 360 — the complete coach system with 7 modules and exclusive bonuses" className="w-full rounded-2xl shadow-2xl shadow-black/50 ring-1 ring-white/20" data-id="element-104" />
      </motion.button>

      <motion.p initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} className="mx-auto mt-6 max-w-xl text-center text-base leading-relaxed text-white/95" data-id="element-105">
        Learn how to attract more students, charge premium rates, retain
        clients, and build a coaching business that grows year after year.
      </motion.p>

      <div className="mx-auto mt-5 flex max-w-md flex-wrap justify-center gap-2" data-id="element-106">
        {BADGES.map(b => <span key={b.label} className="inline-flex items-center gap-1.5 rounded-full border border-white/25 bg-[#101b2d]/95 px-3 py-1.5 text-sm font-600 text-white shadow-md shadow-black/20" data-id="element-107">
            <span aria-hidden data-id="element-108">{b.icon}</span>
            {b.label}
          </span>)}
      </div>

      <div className="mx-auto mt-6 max-w-md" data-id="element-109">
        <BuyButton data-id="element-110" />
      </div>
    </header>;
}